import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  AllTrades: {},
  sleeveDataStageOne: {},
  orders: [],
  locates: {},
  identifier: "",
  validatedData: {},
  finalCrossedTrades: [],
  processId: "",
  swapLoading: false,
  swapStrategies: [],
  swapStrategiesAvailableDate: {},
  swapRebalanceStrategies: [],
  swapRebalanceStrategiesValidity: [],
  swapFinalStrategies: [],
  rebalancerSummary: {},
  crossingLoader: true,
  load: true,
  rebalancerFund: "",
  blacklistedTickers: [],
  loading: false,
  error: null,
};

const rebalancerSlice = createSlice({
  name: "rebalancer",
  initialState,
  reducers: {
    clearRebalancerError: (state) => {
      state.error = null;
    },
    setRebalancerLoading: (state, action) => {
      state.loading = action.payload;
    },
    updateSwapLoading: (state, action) => {
      state.swapLoading = action.payload;
    },
    updateRebalancerFund: (state, action) => {
      state.rebalancerFund = action.payload;
    },
    setRebalancerSummary: (state, action) => {
      state.rebalancerSummary = action.payload;
    },
    setBlacklistedTickers: (state, action) => {
      const { message, result } = action.payload || {};
      if (message === "success") {
        state.blacklistedTickers = result || [];
      } else {
        state.blacklistedTickers = [];
      }
    },
    setAllTrades: (state, action) => {
      state.AllTrades = action.payload;
      state.crossingLoader = false;
    },
    stageTwoOfRebalance: (state, action) => {
      state.AllTrades = action.payload;
      state.crossingLoader = false;
    },
    setSleeveDataStageOne: (state, action) => {
      const { message, data, replace } = action.payload || {};
      if (message === "success") {
        if (replace) {
          Object.keys(data || {}).forEach((key) => {
            if (state.sleeveDataStageOne.hasOwnProperty(key)) {
              state.sleeveDataStageOne[key] = data[key];
            }
          });
        } else {
          state.sleeveDataStageOne = data || {};
        }
      } else {
        state.sleeveDataStageOne = {};
      }
     
    },
    setValidatedData: (state, action) => {
      state.validatedData = action.payload;
    },
    setLocates: (state, action) => {
      state.locates = action.payload.data;
      state.identifier = action.payload.identifier;
    },
    setFinalCrossedTrades: (state, action) => {
      state.finalCrossedTrades = action.payload.orders;
      state.processId = action.payload.processId;
    },
    setRebalancerOrders: (state, action) => {
      state.orders = action.payload;
      state.load = false;
    },
    setSwapStrategies: (state, action) => {
      const { strategies, availableDates } = action.payload || {};
      state.swapStrategies = strategies;
      state.swapStrategiesAvailableDate = availableDates;
      state.swapLoading = false;
    },
    setSwapRebalanceStrategies: (state, action) => {
      const { strategies } = action.payload || {};
      state.swapRebalanceStrategies = strategies;
    },
    setSwapRebalanceStrategiesValidity: (state, action) => {
      const { strategies } = action.payload || {};
      state.swapRebalanceStrategiesValidity = strategies;

      if (strategies) {
        strategies.forEach((strategy) => {
          if (
            strategy.success === false &&
            !strategy.validationErrors &&
            strategy.error
          ) {
            toast.error(strategy.error);
          }
        });
      }
    },
    setSwapFinalStrategies: (state, action) => {
      const { strategies } = action.payload || {};
      state.swapFinalStrategies = strategies;

      if (strategies) {
        let hasError = false;
        strategies.forEach((strategy) => {
          if (
            strategy.success === false &&
            !strategy.validationErrors &&
            strategy.error
          ) {
            hasError = true;
            toast.error(strategy.error);
          }
        });

        if (!hasError) {
          toast.success("Rebalance Successfully Validated");
        }
      }
    },
    rebalancerLocatesRedo: (state, action) => {
      const existingOrders = state.AllTrades.realOrders || [];
      const newOrders = action.payload || [];

      const updatedOrders = newOrders.map((newOrder) => {
        const matchingOrder = existingOrders.find((existingOrder) => {
          return (
            existingOrder.fund === newOrder.fund &&
            existingOrder.strategy === newOrder.strategy &&
            existingOrder.ticker.symbol.toLowerCase() ===
              newOrder.ticker.symbol.toLowerCase() &&
            existingOrder.action === newOrder.action &&
            existingOrder.position === newOrder.position &&
            existingOrder.custodian === newOrder.custodian
          );
        });

        if (matchingOrder) {
          newOrder.prevShareCount = matchingOrder.shareCount;
          if (newOrder.prevShareCount > newOrder.shareCount) {
            newOrder.residual = 0;
          } else {
            newOrder.residual = newOrder.shareCount - newOrder.prevShareCount;
          }
        }

        return newOrder;
      });

      state.AllTrades.realOrders = updatedOrders;
      state.crossingLoader = false;
    },
    clearRebalancer: (state) => {
      state.AllTrades = {};
      state.sleeveDataStageOne = {};
      state.orders = [];
      state.crossingLoader = true;
      state.finalCrossedTrades = [];
      state.processId = "";
      state.blacklistedTickers = [];
      state.swapStrategies = [];
      state.swapStrategiesAvailableDate = {};
      state.swapRebalanceStrategies = [];
      state.swapRebalanceStrategiesValidity = [];
      state.swapFinalStrategies = [];
      state.swapLoading = false;
      state.validatedData = {};
      state.locates = {};
      state.identifier = "";
      state.rebalancerSummary = {};
      state.load = true;
      state.rebalancerFund = "";
    },
  },
});

export const {
  clearRebalancerError,
  setRebalancerLoading,
  updateSwapLoading,
  updateRebalancerFund,
  setRebalancerSummary,
  setBlacklistedTickers,
  setAllTrades,
  stageTwoOfRebalance,
  setSleeveDataStageOne,
  setValidatedData,
  setLocates,
  setFinalCrossedTrades,
  setRebalancerOrders,
  setSwapStrategies,
  setSwapRebalanceStrategies,
  setSwapRebalanceStrategiesValidity,
  setSwapFinalStrategies,
  rebalancerLocatesRedo,
  clearRebalancer,
} = rebalancerSlice.actions;
export default rebalancerSlice.reducer;

// Selectors
export const selectBlacklistedTickers = (state) =>
  state.rebalancer.blacklistedTickers;
export const selectAllTrades = (state) => state.rebalancer.AllTrades;
export const selectSleeveDataStageOne = (state) =>
  state.rebalancer.sleeveDataStageOne;
export const selectRebalancerOrders = (state) => state.rebalancer.orders;
export const selectLocates = (state) => state.rebalancer.locates;
export const selectIdentifier = (state) => state.rebalancer.identifier;
export const selectValidatedData = (state) => state.rebalancer.validatedData;
export const selectFinalCrossedTrades = (state) =>
  state.rebalancer.finalCrossedTrades;
export const selectProcessId = (state) => state.rebalancer.processId;
export const selectSwapLoading = (state) => state.rebalancer.swapLoading;
export const selectSwapStrategies = (state) => state.rebalancer.swapStrategies;
export const selectSwapStrategiesAvailableDate = (state) =>
  state.rebalancer.swapStrategiesAvailableDate;
export const selectSwapRebalanceStrategies = (state) =>
  state.rebalancer.swapRebalanceStrategies;
export const selectSwapRebalanceStrategiesValidity = (state) =>
  state.rebalancer.swapRebalanceStrategiesValidity;
export const selectSwapFinalStrategies = (state) =>
  state.rebalancer.swapFinalStrategies;
export const selectRebalancerSummary = (state) =>
  state.rebalancer.rebalancerSummary;
export const selectCrossingLoader = (state) => state.rebalancer.crossingLoader;
export const selectLoad = (state) => state.rebalancer.load;
export const selectRebalancerFund = (state) => state.rebalancer.rebalancerFund;
export const selectRebalancerLoading = (state) => state.rebalancer.loading;
export const selectRebalancerError = (state) => state.rebalancer.error;
